export default {
    title_list: 'Occasions',
    title_page: 'Occasion',
    title_create_page: 'Create an occasion',
    title_edit_page: 'Change occasion',

    filter: {
        labels: {
            title: 'Title',
        }
    },

    table: {
        labels: {
            id: 'ID',
            title: 'Title',
            position: 'Order',
        }
    },

    buttons: {

    },

    form: {
        title: 'Title',
        position: 'Order',
    },
}
